import { post, get } from './requests'

export const startTask = key => payload =>
  post(
    ['api', 'tasks', 'start'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const completeTask = key => (id, payload) =>
  post(
    ['api', 'tasks', id, 'complete'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const stopTask = key => (id, payload) =>
  post(
    ['api', 'tasks', id, 'stop'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const continueTask = key => (id, payload) =>
  post(
    ['api', 'tasks', id, 'continue'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const getTasks = key =>
  get(['api', 'tasks'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const getTask = (key, { id }) =>
  get(['api', 'tasks', id], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const updateTaskStatus = key => id =>
  post(['api', 'tasks', id, 'continued-task'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const checkCurrentTask = key =>
  post(['api', 'tasks', 'check-current'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const addTask = key => payload =>
  post(
    ['api', 'tasks', 'add'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const deleteTask = key => payload =>
  post(
    ['api', 'tasks', 'delete'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )



// WEBPACK FOOTER //
// ./src/services/task.js